import type { FunctionComponent } from "react";
import { AddSocialModalPartial } from "../../../../partials/admin/menus/socials/add-social-modal.admin.partials";

export const AddSocialModalAdminScreen: FunctionComponent = () => {
  return <AddSocialModalPartial />;
};
